/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LicenseStatus } from './LicenseStatus';
import {
    LicenseStatusFromJSON,
    LicenseStatusFromJSONTyped,
    LicenseStatusToJSON,
    LicenseStatusToJSONTyped,
} from './LicenseStatus';

/**
 * License state of the organization and the seats it uses.
 * @export
 * @interface LicenseSummary
 */
export interface LicenseSummary {
    /**
     * 
     * @type {LicenseStatus}
     * @memberof LicenseSummary
     */
    status: LicenseStatus;
    /**
     * 
     * @type {string}
     * @memberof LicenseSummary
     */
    license_type?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof LicenseSummary
     */
    valid_until?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof LicenseSummary
     */
    max_users: number;
    /**
     * 
     * @type {number}
     * @memberof LicenseSummary
     */
    used_seats: number;
}



/**
 * Check if a given object implements the LicenseSummary interface.
 */
export function instanceOfLicenseSummary(value: object): value is LicenseSummary {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('max_users' in value) || value['max_users'] === undefined) return false;
    if (!('used_seats' in value) || value['used_seats'] === undefined) return false;
    return true;
}

export function LicenseSummaryFromJSON(json: any): LicenseSummary {
    return LicenseSummaryFromJSONTyped(json, false);
}

export function LicenseSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): LicenseSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'status': LicenseStatusFromJSON(json['status']),
        'license_type': json['license_type'] == null ? undefined : json['license_type'],
        'valid_until': json['valid_until'] == null ? undefined : (new Date(json['valid_until'])),
        'max_users': json['max_users'],
        'used_seats': json['used_seats'],
    };
}

export function LicenseSummaryToJSON(json: any): LicenseSummary {
    return LicenseSummaryToJSONTyped(json, false);
}

export function LicenseSummaryToJSONTyped(value?: LicenseSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': LicenseStatusToJSON(value['status']),
        'license_type': value['license_type'],
        'valid_until': value['valid_until'] == null ? undefined : ((value['valid_until'] as any).toISOString()),
        'max_users': value['max_users'],
        'used_seats': value['used_seats'],
    };
}

